export default __webpack_public_path__ + "static/media/Blackmarrow Helm.dbdc1d14.jpg";